module.exports = __webpack_public_path__ + "static/media/health_clicked.ac522b1a.png";